export default __webpack_public_path__ + "static/media/account.14c2bba6.svg";